import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Tabs,
  Tab,
  Box,
  Slide,
  Avatar,
  Button,
  useMediaQuery,
} from "@mui/material";
import { Grid } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";
import AuthViewController from "../../redux/actions/AuthViewController";
import BasicDetailEditForm from "./Tabs/BasicDetails";
import EducationDetailEditForm from "./Tabs/EducationDetails";
import ExperienceDetailEditForm from "./Tabs/Experience";
import AccountDetailEditForm from "./Tabs/SalaryDetails";
import EmployerViewController from "../../redux/actions/EmployerApiAction";
import { getUserInfoFromToken } from "../../utils/authUtils";
import ProtectedImage from "../../components/ProtectedImage";
import ProfileImageUpload from "./Tabs/ProfileUpload";
import { BRAND, primaryButtonSx } from "../../components/auth/authTheme";
import {
  ProfileFieldList,
  ProfileSectionCard,
} from "./profileViewHelpers";
import {
  DESKTOP_TAB_LABELS,
  MOBILE_TAB_LABELS,
  EDIT_SECTION_LABELS,
  shouldRenderSection,
} from "./profileTabConfig";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const MobileTransition = React.forwardRef(function MobileTransition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const mobileEditButtonSx = {
  ...primaryButtonSx,
  minHeight: 32,
  py: 0.5,
  px: 1.5,
  fontSize: "0.75rem",
  borderRadius: "8px",
  boxShadow: "none",
};

const EditProfileDialog = ({ open, handleClose }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { updateEmployee } = EmployeeProfileVeiwController();
  const { updateEmployer } = EmployerViewController();
  const { employee_data } = useSelector((state) => state.employeeProfile);
  const { getUserDetails } = AuthViewController();
  const { userDetails } = useSelector((state) => state.auth);
  const [editingSection, setEditingSection] = useState(null);
  // const userType = localStorage.getItem("user_type");
   const [userType, setUserType] = useState(null);
      const [userId, setUserId] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [isImageDialogOpen, setIsImageDialogOpen] = useState(false);

  useEffect(() => {
    if (open) {
      dispatch(getUserDetails());
    }
  }, [open, dispatch]);

  useEffect(() => {
    if (!open) {
      setTabIndex(0);
      setEditingSection(null);
    }
  }, [open]);

  const handleCloseDialog = () => {
    setEditingSection(null);
    handleClose();
  };

  const activeTabLabels = isMobile ? MOBILE_TAB_LABELS : DESKTOP_TAB_LABELS;
  const renderSection = (sectionIndex) =>
    shouldRenderSection(sectionIndex, tabIndex, isMobile, editingSection);
  const mobileEditing = isMobile && Boolean(editingSection);

  const roleLabel =
    userDetails?.employee_id ||
    (userType === "Employer" ? "Employer" : userType) ||
    "N/A";

  const basicFields = [
    { label: "Email", value: userDetails?.email },
    { label: "Mobile", value: userDetails?.mobile_number },
    { label: "Gender", value: userDetails?.gender },
    { label: "Nationality", value: userDetails?.nationality },
    { label: "Date of Birth", value: userDetails?.profile_data?.date_of_birth },
    { label: "Aadhar Number", value: userDetails?.profile_data?.aadhar_number },
    {
      label: "Residential Address",
      value: userDetails?.profile_data?.address?.residentialAddress,
    },
    {
      label: "Current Address",
      value: userDetails?.profile_data?.address?.currentAddress,
    },
    { label: "About", value: userDetails?.profile_data?.about },
  ];

  const professionalFields = [
    { label: "Designation", value: userDetails?.profile_data?.designation_name },
    { label: "Department", value: userDetails?.profile_data?.department_name },
    { label: "Employment Type", value: userDetails?.profile_data?.employment_type },
    { label: "Work Location", value: userDetails?.profile_data?.work_location },
    { label: "Shift Timing", value: userDetails?.profile_data?.shift_timing },
    { label: "Weekly Off", value: userDetails?.profile_data?.weekly_off },
    { label: "Working Hours", value: userDetails?.profile_data?.working_hours },
  ];

  const handleBasicDetailSave = (values) => {
    const payload = {
      id: userDetails.id,
      first_name: values.first_name,
      last_name: values.last_name,
      email: values.email,
      mobile_number: values.mobile_number,
      gender: values.gender,
      nationality: values.nationality,
      profile: {
        date_of_birth: values.date_of_birth,
        aadhar_number: values.aadhar_number,
        about: values.about,
        address: {
          residentialAddress: values.residentialAddress,
          currentAddress: values.currentAddress
        },
        profile_image: values.profile_image,
        education: values.education || []
      }
    };

    dispatch(updateEmployee(payload.id, payload));

    // Update the local object so the UI reflects changes
    userDetails.first_name = payload.first_name;
    userDetails.last_name = payload.last_name;
    userDetails.email = payload.email;
    userDetails.mobile_number = payload.mobile_number;
    userDetails.gender = payload.gender;
    userDetails.nationality = payload.nationality;
    userDetails.profile_data = payload.profile;

    setEditingSection(null);
  };

  const handleCancelEdit = () => setEditingSection(null);
  const formikRef = useRef();
                        useEffect(() => {
                        const { userType, userId } = getUserInfoFromToken();
                        setUserType(userType);
                        setUserId(userId);
                      }, []);

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      fullScreen={isMobile}
      TransitionComponent={isMobile ? MobileTransition : Transition}
      hideBackdrop={!isMobile}
      sx={
        isMobile
          ? {
              "& .MuiBackdrop-root": { bgcolor: "rgba(26, 43, 74, 0.45)" },
            }
          : undefined
      }
      PaperProps={{
        sx: isMobile
          ? {
              m: 0,
              width: "100%",
              maxWidth: "100%",
              height: "100dvh",
              maxHeight: "100dvh",
              borderRadius: 0,
              bgcolor: BRAND.bg,
              display: "flex",
              flexDirection: "column",
            }
          : {
              width: "80%",
              height: "100vh",
              position: "fixed",
              top: 0,
              right: 0,
              m: 0,
              borderRadius: 0,
              boxShadow: 4,
              overflow: "hidden",
              maxWidth: "none",
              maxHeight: "100%",
            },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          p: isMobile ? 1.25 : 2,
          bgcolor: "#fff",
          borderBottom: `1px solid ${BRAND.border}`,
          flexShrink: 0,
        }}
      >
        {isMobile && (
          <IconButton
            onClick={handleCloseDialog}
            aria-label="Close profile"
            sx={{ color: BRAND.navy, ml: -0.5 }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0, flex: 1 }}>
          <Avatar
            sx={{
              width: isMobile ? 44 : 56,
              height: isMobile ? 44 : 56,
              bgcolor: BRAND.orange,
              fontSize: isMobile ? "0.875rem" : "1.25rem",
              flexShrink: 0,
            }}
          >
            {userDetails?.profile_data?.profile_image ? (
              <ProtectedImage
                path={userDetails.profile_data.profile_image}
                alt={`${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            ) : (
              `${userDetails?.first_name?.[0] || ""}${userDetails?.last_name?.[0] || ""}`
            )}
          </Avatar>

          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontWeight: 700,
                color: BRAND.navy,
                fontSize: isMobile ? "1rem" : "1.25rem",
                lineHeight: 1.25,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {userDetails?.first_name} {userDetails?.last_name}
            </Typography>
            <Typography
              sx={{
                color: BRAND.muted,
                fontSize: "0.8125rem",
                lineHeight: 1.3,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {roleLabel}
              {!isMobile && userDetails?.profile_data?.designation_name
                ? ` · ${userDetails.profile_data.designation_name}`
                : ""}
            </Typography>
          </Box>
        </Box>

        {!isMobile && (
          <IconButton onClick={handleCloseDialog} aria-label="Close profile">
            <CloseIcon />
          </IconButton>
        )}
      </Box>

      {/* Body with Tabs and Content */}
      <DialogContent
        sx={{
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          p: isMobile ? 1.5 : 2,
          pt: isMobile ? 1.25 : 2,
          flex: 1,
          bgcolor: isMobile ? BRAND.bg : "#fff",
          pb: mobileEditing ? "148px !important" : undefined,
        }}
      >
        {mobileEditing && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              mb: 1.25,
              mx: -0.5,
            }}
          >
            <IconButton
              onClick={handleCancelEdit}
              aria-label="Cancel editing"
              sx={{ color: BRAND.navy, ml: -0.5 }}
              size="small"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography
              sx={{
                fontWeight: 700,
                color: BRAND.navy,
                fontSize: "0.9375rem",
              }}
            >
              Edit {EDIT_SECTION_LABELS[editingSection]}
            </Typography>
          </Box>
        )}

        {!mobileEditing && (
        <Tabs
          value={tabIndex}
          onChange={(_e, newValue) => {
            setTabIndex(newValue);
            setEditingSection(null);
          }}
          variant={isMobile ? "fullWidth" : "scrollable"}
          scrollButtons={isMobile ? false : "auto"}
          allowScrollButtonsMobile
          sx={{
            borderBottom: isMobile ? "none" : `1px solid ${BRAND.border}`,
            mb: isMobile ? 1.25 : 2,
            minHeight: isMobile ? 44 : 48,
            bgcolor: isMobile ? "#fff" : "transparent",
            borderRadius: isMobile ? "14px" : 0,
            border: isMobile ? `1px solid ${BRAND.border}` : "none",
            boxShadow: isMobile ? "0 1px 6px rgba(26, 43, 74, 0.04)" : "none",
            px: isMobile ? 0.25 : 0,
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: isMobile ? "0.8125rem" : "0.875rem",
              minHeight: isMobile ? 44 : 48,
              color: BRAND.muted,
              px: isMobile ? 1.5 : 2,
              minWidth: isMobile ? "auto" : 90,
            },
            "& .Mui-selected": {
              color: `${BRAND.orangeHover} !important`,
              fontWeight: 700,
            },
            "& .MuiTabs-indicator": {
              backgroundColor: BRAND.orangeHover,
              height: 3,
              borderRadius: "3px 3px 0 0",
            },
            "& .MuiTabs-scrollButtons": {
              display: isMobile ? "none" : "flex",
            },
          }}
        >
          {activeTabLabels.map((label, index) => (
            <Tab key={index} label={label} />
          ))}
        </Tabs>
        )}

        {/* Tab Content */}
        {renderSection(0) && (
  <Box>
    {editingSection !== "basic" ? (
      isMobile ? (
        <>
          <ProfileSectionCard
            title="Basic Detail"
            action={
              userType === "Employee" ? (
                <Button
                  size="small"
                  onClick={() => setEditingSection("basic")}
                  sx={mobileEditButtonSx}
                >
                  Edit
                </Button>
              ) : null
            }
          >
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 1.5, mb: 1 }}>
              <Box position="relative" display="inline-block">
                <Avatar
                  sx={{
                    width: 88,
                    height: 88,
                    border: `2px solid ${BRAND.navy}`,
                    fontSize: "1.75rem",
                    bgcolor: BRAND.orange,
                  }}
                >
                  {userDetails?.profile_data?.profile_image ? (
                    <ProtectedImage
                      path={userDetails.profile_data.profile_image}
                      alt={`${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <>
                      {userDetails?.first_name?.[0]?.toUpperCase() || "N"}
                      {userDetails?.last_name?.[0]?.toUpperCase() || "N"}
                    </>
                  )}
                </Avatar>
                {userType === "Employee" && (
                  <IconButton
                    size="small"
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      right: -4,
                      bgcolor: "#fff",
                      border: `1px solid ${BRAND.border}`,
                      width: 28,
                      height: 28,
                    }}
                    onClick={() => setIsImageDialogOpen(true)}
                  >
                    <EditIcon sx={{ fontSize: 14 }} />
                  </IconButton>
                )}
              </Box>
              <Typography sx={{ fontWeight: 700, color: BRAND.navy, mt: 1 }}>
                {userDetails?.first_name} {userDetails?.last_name}
              </Typography>
            </Box>
            <ProfileFieldList fields={basicFields} />
          </ProfileSectionCard>
        </>
      ) : (
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            sx={{ pl: 2 }}
          >
            <Typography variant="h6">Basic Detail</Typography>
            {editingSection !== "basic" && userType === "Employee" && (
              <EditIcon
                sx={{ color: "gray", cursor: "pointer" }}
                onClick={() => setEditingSection("basic")}
              />
            )}
          </Box>
          <Grid container spacing={2} mt={4}>
            <Grid item xs={12} sm={4} md={3}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <Box position="relative" display="inline-block">
                  <Avatar
                    sx={{
                      width: 100,
                      height: 100,
                      mb: 1,
                      border: "2px solid #004466",
                      fontSize: 36,
                    }}
                  >
                    {userDetails?.profile_data?.profile_image ? (
                      <ProtectedImage
                        path={userDetails.profile_data.profile_image}
                        alt={`${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    ) : (
                      <>
                        {userDetails?.first_name?.[0]?.toUpperCase() || "N"}
                        {userDetails?.last_name?.[0]?.toUpperCase() || "N"}
                      </>
                    )}
                  </Avatar>
                  <IconButton
                    size="small"
                    sx={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      bgcolor: "white",
                      border: "1px solid #ccc",
                    }}
                    onClick={() => setIsImageDialogOpen(true)}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Box>
                <Typography variant="subtitle1" fontWeight="bold">
                  {userDetails?.first_name} {userDetails?.last_name}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={8} md={9}>
              <Grid container spacing={2}>
                {basicFields.map(({ label, value }) => (
                  <Grid item xs={12} sm={6} key={label}>
                    <Typography>
                      <strong>{label}:</strong> {value || "N/A"}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </>
      )
    ) : (
      <BasicDetailEditForm
        userDetails={userDetails}
        onCancel={handleCancelEdit}
        onSave={handleBasicDetailSave}
      />
    )}

    <ProfileImageUpload
      open={isImageDialogOpen}
      onClose={() => setIsImageDialogOpen(false)}
      currentImage={userDetails?.profile_data?.profile_image}
      userId={userDetails?.id}
    />
  </Box>
)}
        {renderSection(1) && (
          <Box sx={{ ml: isMobile ? 0 : 2 }}>
            {isMobile ? (
              <ProfileSectionCard title="Professional Detail">
                <ProfileFieldList fields={professionalFields} />
              </ProfileSectionCard>
            ) : (
              <>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography variant="h6">Professional Detail</Typography>
                </Box>
                <Grid container spacing={2}>
                  {professionalFields.map(({ label, value }) => (
                    <Grid item xs={12} sm={6} key={label}>
                      <Typography>
                        <strong>{label}:</strong> {value || "N/A"}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Box>
        )}

        {renderSection(2) && (
          <Box sx={{ ml: isMobile ? 0 : 2 }}>
            {isMobile ? (
              editingSection === "education" ? (
                <EducationDetailEditForm
                  userDetails={userDetails}
                  onCancel={() => setEditingSection(null)}
                  onSave={(payload) => {
                    dispatch(updateEmployee(payload.id, payload));
                    userDetails.profile_data.education =
                      payload.profile.education;
                    setEditingSection(null);
                  }}
                />
              ) : (
                <ProfileSectionCard
                  title="Education Detail"
                  action={
                    userType === "Employee" ? (
                      <Button
                        size="small"
                        onClick={() => setEditingSection("education")}
                        sx={mobileEditButtonSx}
                      >
                        Edit
                      </Button>
                    ) : null
                  }
                >
                  {userDetails?.profile_data?.education?.length > 0 ? (
                    userDetails.profile_data.education.map((edu, index) => (
                      <Box
                        key={index}
                        sx={{
                          py: 1.15,
                          borderBottom:
                            index < userDetails.profile_data.education.length - 1
                              ? `1px solid ${BRAND.border}`
                              : "none",
                        }}
                      >
                        <ProfileFieldList
                          fields={[
                            { label: "College Name", value: edu.name },
                            { label: "Percentage", value: edu.percentage },
                            { label: "Passing Year", value: edu.passingYear },
                          ]}
                        />
                      </Box>
                    ))
                  ) : (
                    <Typography sx={{ color: BRAND.muted, py: 1 }}>
                      No education details available.
                    </Typography>
                  )}
                </ProfileSectionCard>
              )
            ) : (
              <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h6">Education Detail</Typography>
              {editingSection !== "education" && userType === "Employee" && (
                <EditIcon
                  sx={{ color: "gray", cursor: "pointer" }}
                  onClick={() => setEditingSection("education")}
                />
              )}
            </Box>

            {editingSection !== "education" ? (
              <Grid container spacing={2}>
                {userDetails?.profile_data?.education?.length > 0 ? (
                  userDetails.profile_data.education.map((edu, index) => (
                    <React.Fragment key={index}>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>College Name:</strong> {edu.name || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>Percentage:</strong> {edu.percentage || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>Passing Year:</strong>{" "}
                          {edu.passingYear || "N/A"}
                        </Typography>
                      </Grid>
                    </React.Fragment>
                  ))
                ) : (
                  <Grid item xs={12}>
                    <Typography>No education details available.</Typography>
                  </Grid>
                )}
              </Grid>
            ) : (
              <EducationDetailEditForm
                userDetails={userDetails}
                onCancel={() => setEditingSection(null)}
                onSave={(payload) => {
                  dispatch(updateEmployee(payload.id, payload));
                  userDetails.profile_data.education =
                    payload.profile.education;
                  setEditingSection(null);
                }}
              />
            )}
              </>
            )}
          </Box>
        )}

        {renderSection(3) && (
          <Box sx={{ ml: isMobile ? 0 : 2 }}>
            {isMobile ? (
              editingSection === "experience" ? (
                <ExperienceDetailEditForm
                  userDetails={userDetails}
                  onCancel={() => setEditingSection(null)}
                  onSave={(payload) => {
                    dispatch(updateEmployee(payload.id, payload));
                    userDetails.profile_data.experience =
                      payload.profile.experience;
                    setEditingSection(null);
                  }}
                />
              ) : (
                <ProfileSectionCard
                  title="Experience Detail"
                  action={
                    userType === "Employee" ? (
                      <Button
                        size="small"
                        onClick={() => setEditingSection("experience")}
                        sx={mobileEditButtonSx}
                      >
                        Edit
                      </Button>
                    ) : null
                  }
                >
                  {userDetails?.profile_data?.experience?.length > 0 ? (
                    userDetails.profile_data.experience.map((exp, index) => (
                      <Box
                        key={index}
                        sx={{
                          py: 1.15,
                          borderBottom:
                            index < userDetails.profile_data.experience.length - 1
                              ? `1px solid ${BRAND.border}`
                              : "none",
                        }}
                      >
                        <ProfileFieldList
                          fields={[
                            { label: "Company Name", value: exp.company },
                            { label: "Joining Date", value: exp.joining },
                            { label: "End Date", value: exp.end },
                            { label: "Designation", value: exp.designation },
                          ]}
                        />
                      </Box>
                    ))
                  ) : (
                    <Typography sx={{ color: BRAND.muted, py: 1 }}>
                      No experience details available.
                    </Typography>
                  )}
                </ProfileSectionCard>
              )
            ) : (
              <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h6">Experience Detail</Typography>
              {editingSection !== "experience" && userType === "Employee" && (
                <EditIcon
                  sx={{ color: "gray", cursor: "pointer" }}
                  onClick={() => setEditingSection("experience")}
                />
              )}
            </Box>

            {editingSection !== "experience" ? (
              <Grid container spacing={2}>
                {userDetails?.profile_data?.experience &&
                userDetails.profile_data.experience.length > 0 ? (
                  userDetails.profile_data.experience.map((exp, index) => (
                    <React.Fragment key={index}>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>Company Name:</strong> {exp.company || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>Joining Date:</strong> {exp.joining || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>End Date:</strong> {exp.end || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>Designation:</strong>{" "}
                          {exp.designation || "N/A"}
                        </Typography>
                      </Grid>
                    </React.Fragment>
                  ))
                ) : (
                  <Grid item xs={12}>
                    <Typography>No experience details available.</Typography>
                  </Grid>
                )}
              </Grid>
            ) : (
              <ExperienceDetailEditForm
                userDetails={userDetails}
                onCancel={() => setEditingSection(null)}
                onSave={(payload) => {
                  dispatch(updateEmployee(payload.id, payload));
                  userDetails.profile_data.experience =
                    payload.profile.experience;
                  setEditingSection(null);
                }}
              />
            )}
              </>
            )}
          </Box>
        )}

        {renderSection(4) && (
          <Box sx={{ ml: isMobile ? 0 : 2 }}>
            {isMobile ? (
              <>
                {editingSection !== "account" && (
                  <>
                    <ProfileSectionCard title="Salary Summary">
                      <ProfileFieldList
                        fields={[
                          {
                            label: "Basic Salary",
                            value: userDetails?.employee_salary?.basic_salary
                              ? `₹${userDetails.employee_salary.basic_salary}`
                              : null,
                          },
                          {
                            label: "Gross Salary",
                            value: userDetails?.employee_salary?.gross_salary
                              ? `₹${userDetails.employee_salary.gross_salary}`
                              : null,
                          },
                          {
                            label: "Net Salary",
                            value: userDetails?.employee_salary?.net_salary
                              ? `₹${userDetails.employee_salary.net_salary}`
                              : null,
                          },
                        ]}
                      />
                    </ProfileSectionCard>

                    {userDetails?.employee_salary?.deductions &&
                      Object.keys(userDetails.employee_salary.deductions).length > 0 && (
                        <ProfileSectionCard title="Deductions">
                          <ProfileFieldList
                            fields={Object.entries(userDetails.employee_salary.deductions).map(
                              ([key, value]) => ({
                                label: key
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (c) => c.toUpperCase()),
                                value: `₹${value}`,
                              })
                            )}
                          />
                        </ProfileSectionCard>
                      )}

                    <ProfileSectionCard
                      title="Account Details"
                      action={
                        userType === "Employee" ? (
                          <Button
                            size="small"
                            onClick={() => setEditingSection("account")}
                            sx={mobileEditButtonSx}
                          >
                            Edit
                          </Button>
                        ) : null
                      }
                    >
                      <ProfileFieldList
                        fields={[
                          {
                            label: "Bank Name",
                            value: userDetails?.employee_salary?.bank_name,
                          },
                          {
                            label: "Bank Branch",
                            value: userDetails?.employee_salary?.bank_branch,
                          },
                          {
                            label: "Account Number",
                            value: userDetails?.employee_salary?.account_number,
                          },
                          {
                            label: "PF Number",
                            value: userDetails?.employee_salary?.pf_number,
                          },
                          {
                            label: "PAN Number",
                            value: userDetails?.employee_salary?.pan_number,
                          },
                          {
                            label: "ESI Number",
                            value: userDetails?.employee_salary?.esi_number,
                          },
                          {
                            label: "IFSC Code",
                            value: userDetails?.employee_salary?.ifsc_code,
                          },
                        ]}
                      />
                    </ProfileSectionCard>
                  </>
                )}

                {editingSection === "account" && (
                  <AccountDetailEditForm
                    userDetails={userDetails}
                    onCancel={() => setEditingSection(null)}
                    onSave={(payload) => {
                      dispatch(updateEmployee(payload.id, payload));
                      userDetails.employee_salary = {
                        ...userDetails.employee_salary,
                        ...payload.employee_salary,
                      };
                      setEditingSection(null);
                    }}
                  />
                )}
              </>
            ) : (
              <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h6">Salary Detail</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Basic Salary:</strong> ₹
                  {userDetails?.employee_salary?.basic_salary || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Gross Salary:</strong> ₹
                  {userDetails?.employee_salary?.gross_salary || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Net Salary:</strong> ₹
                  {userDetails?.employee_salary?.net_salary || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Deductions:</strong>
                </Typography>
                {userDetails?.employee_salary?.deductions ? (
                  Object.entries(userDetails.employee_salary.deductions).map(
                    ([key, value], index) => (
                      <Typography key={index} sx={{ ml: 2 }}>
                        {key
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase())}
                        : ₹{value}
                      </Typography>
                    )
                  )
                ) : (
                  <Typography sx={{ ml: 2 }}>N/A</Typography>
                )}
              </Grid>
            </Grid>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
              mt={2}
            >
              <Typography variant="h6">Account Details</Typography>
              {editingSection !== "account" && userType === "Employee" && (
                <EditIcon
                  sx={{ color: "gray", cursor: "pointer" }}
                  onClick={() => setEditingSection("account")}
                />
              )}
            </Box>

            {editingSection === "account" ? (
              <AccountDetailEditForm
                userDetails={userDetails}
                onCancel={() => setEditingSection(null)}
                onSave={(payload) => {
                  dispatch(updateEmployee(payload.id, payload));
                  userDetails.employee_salary = {
                    ...userDetails.employee_salary,
                    ...payload.employee_salary
                  };
                  setEditingSection(null);
                }}
              />
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Bank Name:</strong>{" "}
                    {userDetails?.employee_salary?.bank_name || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Bank Branch:</strong>{" "}
                    {userDetails?.employee_salary?.bank_branch || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Account Number:</strong>{" "}
                    {userDetails?.employee_salary?.account_number || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>PF Number:</strong>{" "}
                    {userDetails?.employee_salary?.pf_number || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>PAN Number:</strong>{" "}
                    {userDetails?.employee_salary?.pan_number || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>ESI Number:</strong>{" "}
                    {userDetails?.employee_salary?.esi_number || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>IFSC Code:</strong>{" "}
                    {userDetails?.employee_salary?.ifsc_code || "N/A"}
                  </Typography>
                </Grid>
              </Grid>
            )}
              </>
            )}
          </Box>
        )}

        {renderSection(5) && (
          <Box sx={{ ml: isMobile ? 0 : 2 }}>
            {isMobile ? (
              <ProfileSectionCard title="Leave Detail">
                <ProfileFieldList
                  fields={[
                    {
                      label: "Paid Leave",
                      value: userDetails?.leave_balance?.paid_leave_balance,
                    },
                    {
                      label: "Unpaid Leave",
                      value: userDetails?.leave_balance?.unpaid_leave_balance,
                    },
                    {
                      label: "Casual Leave",
                      value: userDetails?.leave_balance?.casual_leave_balance,
                    },
                    {
                      label: "Sick Leave",
                      value: userDetails?.leave_balance?.sick_leave_balance,
                    },
                    {
                      label: "Maternity Leave",
                      value: userDetails?.leave_balance?.maternity_leave_balance,
                    },
                    {
                      label: "Marriage Leave",
                      value: userDetails?.leave_balance?.marriage_leave_balance,
                    },
                    {
                      label: "Comp Off Leave",
                      value: userDetails?.leave_balance?.compensatory_off_leave_balance,
                    },
                    {
                      label: "Overtime Eligible",
                      value: userDetails?.leave_balance?.overtime_eligible ? "Yes" : "No",
                    },
                  ]}
                />
              </ProfileSectionCard>
            ) : (
              <>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography variant="h6">Leave Detail</Typography>
                </Box>
                <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Paid Leave:</strong>{" "}
                  {userDetails?.leave_balance?.paid_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Unpaid Leave:</strong>{" "}
                  {userDetails?.leave_balance?.unpaid_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Casual Leave:</strong>{" "}
                  {userDetails?.leave_balance?.casual_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Sick Leave:</strong>{" "}
                  {userDetails?.leave_balance?.sick_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Maternity Leave:</strong>{" "}
                  {userDetails?.leave_balance?.maternity_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Marriage Leave:</strong>{" "}
                  {userDetails?.leave_balance?.marriage_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Comp Off Leave:</strong>{" "}
                  {userDetails?.leave_balance?.compensatory_off_leave_balance ||
                    "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Overtime Eligible:</strong>{" "}
                  {userDetails?.leave_balance?.overtime_eligible
                    ? "Yes"
                    : "No" || "N/A"}
                </Typography>
              </Grid>
            </Grid>
              </>
            )}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EditProfileDialog;
